module.exports = __webpack_public_path__ + "img/joker_900.86a25194.png";